import AppRoutes from './routes';
import './app.css';

function App() {
  return <AppRoutes />;
}

export default App;
